/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategicGoalMilestoneStatusUpdate', 'model/StrategicGoalMilestoneStatusUpdatePaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StrategicGoalMilestoneStatusUpdate'), require('../model/StrategicGoalMilestoneStatusUpdatePaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicGoalMilestoneStatusUpdateApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategicGoalMilestoneStatusUpdate, root.ForStractionServiceApi.StrategicGoalMilestoneStatusUpdatePaginationSlice);
  }
}(this, function(ApiClient, StrategicGoalMilestoneStatusUpdate, StrategicGoalMilestoneStatusUpdatePaginationSlice) {
  'use strict';

  /**
   * StrategicGoalMilestoneStatusUpdate service.
   * @module api/StrategicGoalMilestoneStatusUpdateApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StrategicGoalMilestoneStatusUpdateApi. 
   * @alias module:api/StrategicGoalMilestoneStatusUpdateApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the strategicGoalMilestoneStatusUpdateAddAndCreateInsightPut operation.
     * @callback module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateAddAndCreateInsightPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAndCreateInsight
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestoneStatusUpdate} body 
     * @param {module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateAddAndCreateInsightPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.strategicGoalMilestoneStatusUpdateAddAndCreateInsightPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneStatusUpdateAddAndCreateInsightPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneStatusUpdateAddAndCreateInsightPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StrategicGoalMilestoneStatusUpdate/addAndCreateInsight', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneStatusUpdateDeleteGet operation.
     * @callback module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} statusUpdateID 
     * @param {module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicGoalMilestoneStatusUpdateDeleteGet = function(_4SAPIAppID, statusUpdateID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneStatusUpdateDeleteGet";
      }

      // verify the required parameter 'statusUpdateID' is set
      if (statusUpdateID == undefined || statusUpdateID == null) {
        throw "Missing the required parameter 'statusUpdateID' when calling strategicGoalMilestoneStatusUpdateDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'statusUpdateID': statusUpdateID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicGoalMilestoneStatusUpdate/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneStatusUpdateEditPut operation.
     * @callback module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestoneStatusUpdate} body 
     * @param {module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategicGoalMilestoneStatusUpdateEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneStatusUpdateEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneStatusUpdateEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategicGoalMilestoneStatusUpdate/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneStatusUpdateSearchPut operation.
     * @callback module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StrategicGoalMilestoneStatusUpdate>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategicGoalMilestoneStatusUpdate>} body 
     * @param {module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StrategicGoalMilestoneStatusUpdate>}
     */
    this.strategicGoalMilestoneStatusUpdateSearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneStatusUpdateSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneStatusUpdateSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StrategicGoalMilestoneStatusUpdate];

      return this.apiClient.callApi(
        '/StrategicGoalMilestoneStatusUpdate/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategicGoalMilestoneStatusUpdateSearchSlicePut operation.
     * @callback module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StrategicGoalMilestoneStatusUpdatePaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/StrategicGoalMilestoneStatusUpdate} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/StrategicGoalMilestoneStatusUpdateApi~strategicGoalMilestoneStatusUpdateSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StrategicGoalMilestoneStatusUpdatePaginationSlice}
     */
    this.strategicGoalMilestoneStatusUpdateSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategicGoalMilestoneStatusUpdateSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategicGoalMilestoneStatusUpdateSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StrategicGoalMilestoneStatusUpdatePaginationSlice;

      return this.apiClient.callApi(
        '/StrategicGoalMilestoneStatusUpdate/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
